module.exports = __webpack_public_path__ + "static/media/pythonQuest.7e69b337.png";